import React, {useState} from "react";
import DsModal from "../_UI/dsModal";
import Form from "../_UI/dsModal/form.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {setGoogleAuthenticatorModalStatus, setGoogleCodeFailure, withdraw} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";
import OtpInput from 'react-otp-input';




const CabinetGoogleAuthenticatorModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const googleAuthenticatorModalStatus = useSelector((store) => store.cabinet.googleAuthenticatorModalStatus);
    const withdrawStatusErr = useSelector(store => store.cabinet.withdrawStatusErr);

    const [code, setCode] = useState('');

    const handleChange = (val) => {
        if (withdrawStatusErr?.otp){
            dispatch(setGoogleCodeFailure(false));
        }
        setCode(val.replace(/\D/g, '').slice(0, 6));
    };

    const submit = (e) => {
        e.preventDefault();
        if (code.length === 6) {
            // TODO: dispatch(verifyOtp(code)) или вызов API
            closeModal();
        }
    };

    const closeModal = () => {
        dispatch(setGoogleAuthenticatorModalStatus({data: false, status: false, toastHandler: false}));
        setCode('');
    };

    const mainBtnHandler = ()=>{
        if (code.length === 6){
            let newData = googleAuthenticatorModalStatus?.data;
            newData.otp = code;
            dispatch(withdraw(newData, googleAuthenticatorModalStatus?.toastHandler));
        }
    }

    return (
        <DsModal
            open={googleAuthenticatorModalStatus?.status}
            onClose={closeModal}
            size="sm"
            title={t('Введите код подтверждения')}
            subtitle={t('Откройте Google Authenticator и введите 6-значный код')}
        >
            <form onSubmit={submit} className={withdrawStatusErr?.otp ? Form.otpErr : ''}>
                <OtpInput
                    value={code}
                    onChange={handleChange}
                    numInputs={6}
                    shouldAutoFocus
                    renderInput={(inputProps, idx) => (
                        <input
                            {...inputProps}
                            key={idx}
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            className={Form.otpBox}
                        />
                    )}
                    containerStyle={Form.otp}
                />
            </form>
            <div className={`${Form.err} ${Form.center}`}>{withdrawStatusErr?.otp ? t('Код подтверждения введен не верно') : ''}</div>
            <button
                type="button"
                className={`${Form.btnAccent} ${code.length === 6 ? '' : Form.btnDisabled}`}
                onClick={mainBtnHandler}
            >
                {t('Подтвердить')}
            </button>
        </DsModal>
    );
};

export default CabinetGoogleAuthenticatorModal;
